module.exports = __webpack_public_path__ + "img/play_3.184ecc37.png";